module.exports = "pegasus/assets/themelp1/creative/102.png";